// Largeur des colonnes d'un tableau, réglée en tirant le bord droit de l'en-tête.
// Règles pures ; le branchement DOM est dans components/ui/ResizableColumns.tsx.

export const COLUMN_MIN_WIDTH = 56;
export const COLUMN_MAX_WIDTH = 720;
/** Zone sensible, en px, à partir du bord droit d'un en-tête. */
export const COLUMN_GRIP = 7;

export function clampColumnWidth(px: number): number {
  if (!Number.isFinite(px)) return COLUMN_MIN_WIDTH;
  return Math.round(Math.min(COLUMN_MAX_WIDTH, Math.max(COLUMN_MIN_WIDTH, px)));
}

/** Le pointeur est-il sur la poignée (bord droit) d'un en-tête de cette largeur ? */
export function isOnColumnGrip(offsetX: number, headerWidth: number): boolean {
  return headerWidth > 0 && offsetX >= headerWidth - COLUMN_GRIP && offsetX <= headerWidth + 1;
}

/** Clé stable d'une colonne : `data-col` si présent, sinon son libellé. */
export function columnKey(dataCol: string | undefined, text: string | null, index: number): string {
  const explicit = dataCol?.trim();
  if (explicit) return explicit;
  const label = (text ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
  return label || `#${index}`;
}

export type ColumnWidths = Record<string, number>;

export function withColumnWidth(widths: ColumnWidths, key: string, px: number | null): ColumnWidths {
  const next = { ...widths };
  if (px == null) delete next[key];
  else next[key] = clampColumnWidth(px);
  return next;
}

export function columnWidthsStorageKey(collaboratorId: string, tableId: string): string {
  return `${collaboratorId}:${tableId}`;
}
